import { render } from "./InputCaixaDeSelecao.vue?vue&type=template&id=2af618e2&scoped=true"
import script from "./InputCaixaDeSelecao.vue?vue&type=script&lang=js"
export * from "./InputCaixaDeSelecao.vue?vue&type=script&lang=js"

import "./InputCaixaDeSelecao.vue?vue&type=style&index=0&id=2af618e2&lang=scss&scoped=true"
import "./InputCaixaDeSelecao.vue?vue&type=style&index=1&id=2af618e2&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af618e2"],['__file',"src/components/CampoForm/components/InputCaixaDeSelecao.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2af618e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2af618e2', __exports__)) {
    console.log('reload')
    api.reload('2af618e2', __exports__)
  }
  
  module.hot.accept("./InputCaixaDeSelecao.vue?vue&type=template&id=2af618e2&scoped=true", () => {
    console.log('re-render')
    api.rerender('2af618e2', render)
  })

}


export default __exports__